export const state = {
  components: {
    loading: false,
    loaded: false,
    value: undefined,
    error: null
  },
  componentsFilter: {
    selectedCriteria: null,
    availableFilterCriteria: {
      loading: false,
      loaded: false,
      value: null,
      error: null
    }
  }
}
